import { Empty, Space, Table, Tag } from "antd";
import { formatDateAndTime } from "../Common/Utils";
import {
  SyncOutlined,
  CloseCircleOutlined,
  DownloadOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";

const DownloadHistory = ({
  historyDetails,
  paginationDetails,
  setPaginationDetails,
}) => {
  const handlePageChange = (pagination) => {
    setPaginationDetails({
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: "60px",
      align: "center",
    },
    {
      title: "Created On",
      dataIndex: "create",
      key: "create",
      align: "center",
      render: (_, record) => (
        <span>{dayjs(record?.modifiedOn).format("MMM DD YYYY, hh:mm A")}</span>
      ),
    },
    {
      title: "File Type",
      dataIndex: "fileType",
      key: "fileType",
      align: "center",
      render: (_, record) => <span>{"CSV"}</span>,
    },
    {
      title: "From Date",
      dataIndex: "fromDate",
      key: "fromDate",
      align: "center",
      render: (_, record) => (
        <span>{formatDateAndTime(record?.startTime)}</span>
      ),
    },
    {
      title: "To Date",
      dataIndex: "toDate",
      key: "toDate",
      align: "center",
      render: (_, record) => <span>{formatDateAndTime(record?.endTime)}</span>,
    },
    {
      title: "Status",
      key: "status",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          {record.status === "READY" ? (
            <a href={record.url} target="_blank" rel="noreferrer">
              <Tag
                icon={<DownloadOutlined style={{ fontSize: "20px" }} />}
                bordered={false}
                color="success"
                className="request-history-status cursor-pointer"
              >
                <span className="text-color ml05">Ready</span>
              </Tag>
            </a>
          ) : record.status === "PROCESSING" ? (
            <Tag
              icon={<SyncOutlined spin style={{ fontSize: "18px" }} />}
              bordered={false}
              color="processing"
              className="request-history-status"
            >
              <span className="text-color ml05">Processing</span>
            </Tag>
          ) : record.status === "FAILED" ? (
            <Tag
              icon={<CloseCircleOutlined style={{ fontSize: "18px" }} />}
              bordered={false}
              color="error"
              className="request-history-status"
            >
              <span className="text-color ml05">Failed</span>
            </Tag>
          ) : record.status === "EXPIRED" ? (
            <Tag
              icon={<WarningOutlined style={{ fontSize: "18px" }} />}
              bordered={false}
              color="warning"
              className="request-history-status"
            >
              <span className="text-color ml05">Expired</span>
            </Tag>
          ) : null}
        </Space>
      ),
    },
  ];

  return historyDetails?.list?.length > 0 ? (
    <Table
      data-testid="export-histories"
      columns={columns}
      dataSource={historyDetails?.list}
      rowKey={(record) => record?.id}
      scroll={{ x: "100%" }}
      onChange={handlePageChange}
      pagination={{
        current: paginationDetails.current,
        pageSize: paginationDetails.pageSize,
        total: historyDetails?.totalElements,
        showSizeChanger: false,
        showQuickJumper: false,
        hideOnSinglePage: true,
      }}
    />
  ) : (
    <div className="pd3025" data-testid="empty-export-histories">
      <Empty />
    </div>
  );
};
export default DownloadHistory;
